export const factSheets = [
    {
    fields: {
        title: 'Moderna COVID-19 Vaccine EUA Provider Fact Sheet 6m-11y',
        label: 'Moderna COVID-19 Vaccine EUA Provider Fact Sheet 6m-11y',
        productCode: '70588',
        url: 'https://assets.modernatx.com/m/2cbca14044aa8fa5/original/FPI-0718_Moderna-COVID-19-Vaccine-2023-2024-Formula-Fact-Sheet-for-Vaccine-Providers-6m-11y-US-English.pdf'
    }
    },
    {
    fields: {
        title: 'Moderna COVID-19 Vaccine EUA Recipient Fact Sheet 6m-11y',
        label: 'Moderna COVID-19 Vaccine EUA Recipient Fact Sheet 6m-11y',
        productCode: '70588',
        url: 'https://assets.modernatx.com/m/c8a870daf3d6e5d/original/FPI-0719_Moderna-COVID-19-Vaccine-2023-2024-Formula-Fact-Sheet-for-Vaccine-Recipients-6m-11y-US-English.pdf'
    }
    },
    {
    fields: {
        title: 'Spikevax Prescribing Information 12y+',
        label: 'Spikevax Prescribing Information 12y+',
        productCode: '80291',
        url: 'https://assets.modernatx.com/m/7ce607d0bf1f0e20/original/FPI-0717_Spikevax-2023-2024-Formula-Prescribing-Information-PI-12y-US-English.pdf'
    }
    },
    {
    fields: {
        title: 'Spikevax Patient Information 12y+',
        label: 'Spikevax Patient Information 12y+',
        productCode: '80291',
        url: 'https://assets.modernatx.com/m/4fe30ac736607490/original/PPI-0017_Spikevax-2023-2024-Formula-Patient-Information-12y-US-English.pdf'
    }
    },
    {
    fields: {
        title: 'Prescribing Information for mRESVIA',
        label: 'Prescribing Information for mRESVIA',
        productCode: '70545',
        url: 'https://static.modernatx.com/pm/6cef78f8-8dad-4fc9-83d5-d2fbb7cff867/36130c97-6fb0-4bea-9f2e-fb5be7a90729/36130c97-6fb0-4bea-9f2e-fb5be7a90729_viewable_rendition__v.pdf'
    }
    },
    {
    fields: {
        title: 'Letter of Authorization for EUA',
        label: 'Letter of Authorization for EUA',
        productCode: '70840',
        url: 'https://static.modernatx.com/pm/6cef78f8-8dad-4fc9-83d5-d2fbb7cff867/9a50151f-e863-4a8e-94ba-e54d713691dc/9a50151f-e863-4a8e-94ba-e54d713691dc_viewable_rendition__v.pdf'
    }
    },
    {
    fields: {
        title: 'Fact Sheet for EUA',
        label: 'Fact Sheet for EUA',
        productCode: '70840',
        url: 'https://static.modernatx.com/pm/6cef78f8-8dad-4fc9-83d5-d2fbb7cff867/b6653c87-2627-405c-b151-be87db581e7d/b6653c87-2627-405c-b151-be87db581e7d_viewable_rendition__v.pdf'
    }
    },
    {
    fields: {
        title: 'Prescribing Information for Spikevax',
        label: 'Prescribing Information for Spikevax',
        productCode: '70506',
        url: 'https://static.modernatx.com/pm/6cef78f8-8dad-4fc9-83d5-d2fbb7cff867/5efa7d9d-05e8-46b5-945a-637c2867bd00/5efa7d9d-05e8-46b5-945a-637c2867bd00_viewable_rendition__v.pdf'
    }
    }
]